export {};

export enum DistanceUnitBase {
    feet = "feet",
    yards = "yards",
    meters = "meters"
}

export enum DistanceUnitShort {
    feet = "ft",
    miles = "mi",
    yards = "yds",
    meters = "m",
    kilometers = "km"
}

export enum DistanceUnitLong {
    feet = "feet",
    miles = "miles",
    yards = "yards",
    meters = "meters",
    kilometers = "kilometers"
}

declare global {
    interface Number {
        metersToFeet(): number
        metersToYards(): number
        feetToMiles(): number
        feetToMeters(): number
        yardsToMeters(): number
        rounded(value: number): number
        beaconDistance(base: DistanceUnitBase): number
        beaconDistanceUnitLong(base: DistanceUnitBase): DistanceUnitLong
        beaconDistanceUnitShort(base: DistanceUnitBase): DistanceUnitShort
    }
}

Number.prototype.metersToFeet = function(): number { return this.valueOf() * 3.28084; };
Number.prototype.metersToYards = function(): number { return this.valueOf() * 1.09361; };
Number.prototype.feetToMiles = function(): number { return this.valueOf() / 5280; };
Number.prototype.feetToMeters = function(): number { return this.valueOf() / 3.28084; };
Number.prototype.yardsToMeters = function(): number { return this.valueOf() / 1.09361; };

Number.prototype.rounded = function(value: number): number {
   return Math.round(this.valueOf() / value) * value;
};

Number.prototype.beaconDistance = function(base: DistanceUnitBase): number {
    switch (base) {
        case DistanceUnitBase.feet: {
            const feet = this.metersToFeet();

            if (feet >= 0 && feet < 30) {
                return feet.rounded(1);
            } else if (feet >= 30 && feet < 100) {
                return feet.rounded(5);
            } else if (feet >= 100 && feet < 500) {
                return feet.rounded(10);
            } else if (feet >= 500 && feet < 950) {
                return feet.rounded(50);
            } else {
                return parseFloat(feet.feetToMiles().rounded(0.1).toFixed(1));
            }
        }
        case DistanceUnitBase.yards: {
            const yards = this.metersToYards();

            if (yards >= 0 && yards < 30) {
                return yards.rounded(1);
            } else if (yards >= 30 && yards < 100) {
                return yards.rounded(5);
            } else {
                return yards.rounded(10);
            }
        }
        case DistanceUnitBase.meters: {
            const meters = this.valueOf();

            if (meters >= 0 && meters < 30) {
                return meters.rounded(1);
            } else if (meters >= 30 && meters < 100) {
                return meters.rounded(5);
            } else if (meters >= 100 && meters < 500) {
                return meters.rounded(10);
            } else if (meters >= 500 && meters < 950) {
                return meters.rounded(50);
            } else {
                return meters.rounded(100) / 1000;
            }
        }
    }
};

Number.prototype.beaconDistanceUnitShort = function(base: DistanceUnitBase): DistanceUnitShort {
    switch (base) {
        case DistanceUnitBase.feet: {
            const feet = this.metersToFeet();

            if (feet >= 0 && feet < 950) {
                return DistanceUnitShort.feet;
            } else {
                return DistanceUnitShort.miles;
            }
        }
        case DistanceUnitBase.yards: {
            return DistanceUnitShort.yards;
        }
        case DistanceUnitBase.meters: {
            const meters = this.valueOf();

            if (meters >= 0 && meters < 950) {
                return DistanceUnitShort.meters;
            } else {
                return DistanceUnitShort.kilometers;
            }
        }
    }
};

Number.prototype.beaconDistanceUnitLong = function(base: DistanceUnitBase): DistanceUnitLong {
    switch (base) {
        case DistanceUnitBase.feet: {
            const feet = this.metersToFeet();

            if (feet >= 0 && feet < 950) {
                return DistanceUnitLong.feet;
            } else {
                return DistanceUnitLong.miles;
            }
        }
        case DistanceUnitBase.yards: {
            return DistanceUnitLong.yards;
        }
        case DistanceUnitBase.meters: {
            const meters = this.valueOf();

            if (meters >= 0 && meters < 950) {
                return DistanceUnitLong.meters;
            } else {
                return DistanceUnitLong.kilometers;
            }
        }
    }
};